import styled, { keyframes } from 'styled-components'

const scan = keyframes`
  0%,100% { top: 10px; }
  50% { top: 210px; }
`

export const ScannerOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: #05070d;
  overflow: hidden;
  video {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ScanTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 5;
  .x {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    backdrop-filter: blur(6px);
  }
  .t {
    color: #fff;
    font-weight: 700;
    font-size: 15px;
    small {
      display: block;
      font-weight: 500;
      font-size: 12px;
      color: #b9c6e0;
      margin-top: 1px;
    }
  }
`

export const Reticle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -55%);
  width: 240px;
  height: 240px;
  z-index: 4;
  .corner {
    position: absolute;
    width: 34px;
    height: 34px;
    border: 3px solid #fff;
    border-radius: 8px;
  }
  .tl {
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
  }
  .tr {
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
  }
  .bl {
    bottom: 0;
    left: 0;
    border-right: none;
    border-top: none;
  }
  .br {
    bottom: 0;
    right: 0;
    border-left: none;
    border-top: none;
  }
  .line {
    position: absolute;
    left: 8px;
    right: 8px;
    height: 3px;
    border-radius: 3px;
    top: 8px;
    background: linear-gradient(90deg, transparent, #5fd0ff, transparent);
    box-shadow: 0 0 14px 2px rgba(95, 208, 255, 0.7);
    animation: ${scan} 2.2s ease-in-out infinite;
    @media (prefers-reduced-motion: reduce) {
      animation: none;
      top: 118px;
    }
  }
`

export const ScanHint = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 120px;
  text-align: center;
  color: #c7d4ec;
  font-size: 13.5px;
  z-index: 5;
  padding: 0 30px;
  line-height: 1.5;
`

export const ScanManual = styled.div`
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 40px;
  z-index: 5;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    width: 100%;
    box-sizing: border-box;
    padding: 14px;
    border-radius: 14px;
    border: none;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    font: inherit;
    font-weight: 700;
    font-size: 14.5px;
    cursor: pointer;
    backdrop-filter: blur(6px);
  }
`

export const ScanError = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 30px;
  text-align: center;
  color: #e6eefc;
  z-index: 6;
  font-size: 14.5px;
  line-height: 1.5;
`

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const ScanLoading = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 4;
  color: #c7d4ec;
  font-size: 14.5px;
  .spinner {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.15);
    border-top-color: #5fd0ff;
    animation: ${spin} 0.8s linear infinite;
    @media (prefers-reduced-motion: reduce) {
      animation-duration: 2s;
    }
  }
`

export const ScanFeedback = styled.div<{ $tone: 'ok' | 'warn' | 'error' }>`
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 110px;
  z-index: 5;
  padding: 12px 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14.5px;
  line-height: 1.4;
  text-align: center;
  color: #fff;
  background: ${({ $tone }) => ($tone === 'ok' ? 'rgba(22, 128, 61, 0.92)' : $tone === 'warn' ? 'rgba(180, 110, 0, 0.92)' : 'rgba(190, 40, 40, 0.92)')};
`
